import { api } from ".";

export interface IContractModelingAnalysisRequest {
  primaryPayerId: number;
  comparisonPayerIds: number[];
  cptCodes?: string[];
  startDate?: string;
  endDate?: string;
}

export interface IContractModelingComparisonCell {
  payerId: number;
  payerName: string;
  avgRate: number;
  modeledRevenue: number;
  rateChangePercent: number;
}

export interface IContractModelingRow {
  cptCode: string;
  volume: number;
  primaryPayer: {
    avgRate: number;
    revenue: number;
  };
  comparisonPayers: IContractModelingComparisonCell[];
  revenuePotential: number;
}

export interface IContractModelingComparisonTotal {
  payerId: number;
  payerName: string;
  totalModeledRevenue: number;
}

export interface IContractModelingAnalysisResponse {
  rows: IContractModelingRow[];
  totals: {
    primaryPayerRevenue: number;
    comparisonPayerRevenues: IContractModelingComparisonTotal[];
    revenuePotential: {
      current: number;
      potential: number;
      difference: number;
      avgRateChangePercent: number;
    };
  };
}

const contractModelingQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getContractModelingPayersWithData: builder.query<number[], void>({
      query: () => "/contract-modeling/payers-with-data",
      transformResponse: (response: { data: number[] }) => response.data,
      providesTags: ["ContractInsights"],
    }),
    getContractModelingAvailableCptCodes: builder.query<
      string[],
      {
        payerId?: number;
        startDate?: string;
        endDate?: string;
      } | void
    >({
      query: (params) => ({
        url: "/contract-modeling/available-cpt-codes",
        params: params || {},
      }),
      transformResponse: (response: { data: string[] }) => response.data,
      providesTags: ["ContractInsights"],
    }),
    postContractModelingAnalysis: builder.mutation<
      IContractModelingAnalysisResponse,
      IContractModelingAnalysisRequest
    >({
      query: (body) => ({
        url: "/contract-modeling/analysis",
        method: "POST",
        body,
      }),
      transformResponse: (response: {
        data: IContractModelingAnalysisResponse;
      }) => response.data,
    }),
  }),
});

export const {
  useGetContractModelingPayersWithDataQuery,
  useGetContractModelingAvailableCptCodesQuery,
  usePostContractModelingAnalysisMutation,
} = contractModelingQueries;
